

import { Observable, of } from 'rxjs';

import { switchMap } from 'rxjs/operators';   

import {Component, OnInit} from '@angular/core';
import {CalculateHistoryformrule} from './calculateHistoryformrule';  
import {ActivatedRoute, Params} from '@angular/router';
import {Location} from '@angular/common';
import {CalculateHistoryservice} from '../services/calculateHistoryservice.service';

@Component({
  selector: 'calculateHistoryDetail',
  templateUrl: './calculateHistoryDetail.component.html',
  styleUrls: ['../app.component.css']
})

export class CalculateHistoryDetail implements OnInit{
  calculateHistoryformrule: CalculateHistoryformrule;

  constructor(
    private calculateHistoryservice: CalculateHistoryservice,
    private route: ActivatedRoute,
    private location: Location
  ){};

  ngOnInit(): void{
    this.route.params
      .pipe(switchMap((params: Params) => this.calculateHistoryservice.get(params['id'])))
      .subscribe(calculateHistoryformrule => this.calculateHistoryformrule = calculateHistoryformrule);
  }

  goBack(): void{
    this.location.back();
  }
}
